(function () {
  const filterState = {
    active: 'available',
  };

  function productItems() {
    return Array.from(document.querySelectorAll('.window-shopping-page #product-grid .grid__item[data-window-restock]'));
  }

  function updateCount(visibleCount) {
    const countText = visibleCount === 1 ? '1 product' : `${visibleCount} products`;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount, .product-count__text span').forEach((element) => {
      if (element) element.textContent = countText;
    });
  }

  function applyFilter() {
    const items = productItems();
    let visibleCount = 0;

    items.forEach((item) => {
      const shouldShow = filterState.active === 'all' || item.dataset.windowRestock === 'true';
      item.hidden = !shouldShow;
      item.classList.toggle('window-shopping-restock-hidden', !shouldShow);
      if (shouldShow) visibleCount += 1;
    });

    updateCount(visibleCount);
  }

  function setActive(button) {
    const toggle = button.closest('[data-window-restock-toggle]');
    if (!toggle) return;

    filterState.active = button.dataset.windowRestockFilter || 'available';
    toggle.querySelectorAll('[data-window-restock-filter]').forEach((option) => {
      const isActive = option === button;
      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    applyFilter();
  }

  function init() {
    document.querySelectorAll('[data-window-restock-toggle] [data-window-restock-filter]').forEach((button) => {
      button.addEventListener('click', () => setActive(button));
    });

    applyFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
